const permissions = {
  // User
  USER_GET: window.BigInt(1) << window.BigInt(0),
  USER_PATCH: window.BigInt(1) << window.BigInt(1),
  // Accounts
  ACCOUNT_GET: window.BigInt(1) << window.BigInt(2),
  ACCOUNT_PATCH: window.BigInt(1) << window.BigInt(3),
  ACCOUNT_DELETE: window.BigInt(1) << window.BigInt(4),
  ACCOUNT_CREATE: window.BigInt(1) << window.BigInt(5),
  ACCOUNTS_GET: window.BigInt(1) << window.BigInt(6),
  // Account-Users
  ACCOUNT_USER_GET: window.BigInt(1) << window.BigInt(7),
  ACCOUNT_USER_PATCH: window.BigInt(1) << window.BigInt(8),
  ACCOUNT_USER_DELETE: window.BigInt(1) << window.BigInt(9),
  ACCOUNT_USER_CREATE: window.BigInt(1) << window.BigInt(10),
  ACCOUNT_USERS_GET: window.BigInt(1) << window.BigInt(11),
  // Patients
  PATIENT_GET: window.BigInt(1) << window.BigInt(12),
  PATIENT_PATCH: window.BigInt(1) << window.BigInt(13),
  PATIENT_DELETE: window.BigInt(1) << window.BigInt(14),
  PATIENT_CREATE: window.BigInt(1) << window.BigInt(15),
  PATIENTS_GET: window.BigInt(1) << window.BigInt(16),
  // Orders
  ORDER_GET: window.BigInt(1) << window.BigInt(17),
  ORDER_PATCH: window.BigInt(1) << window.BigInt(18),
  ORDER_DELETE: window.BigInt(1) << window.BigInt(19),
  ORDER_CREATE: window.BigInt(1) << window.BigInt(20),
  ORDERS_GET: window.BigInt(1) << window.BigInt(21),
  ORDER_SURVEY_CREATE: window.BigInt(1) << window.BigInt(24),
  // Dashboard
  DASHBOARD_GET: window.BigInt(1) << window.BigInt(15),
  // Assessment
  SURVEY_ACCEPT_RESULTS: window.BigInt(1) << window.BigInt(28),
  SURVEY_ACCEPT_RESULTS_SPECIFY_PROVIDER: window.BigInt(1) << window.BigInt(33),

  ACCOUNT_PATCH_DISABLE_ORDERS: window.BigInt(1) << window.BigInt(29),
  ACCOUNT_PATCH_DISABLE_ASSESSMENTS: window.BigInt(1) << window.BigInt(30),
  ACCOUNT_GET_ALLERGIEND_RESOURCES: window.BigInt(1) << window.BigInt(31),
  ACCOUNT_PATCH_ALLERGIEND_RESOURCES: window.BigInt(1) << window.BigInt(32),
  ACCOUNT_PATCH_RESOURCE_ALL: window.BigInt(1) << window.BigInt(44),
  ACCOUNT_PATCH_ENABLE_CLAIM_MANAGEMENT: window.BigInt(1) << window.BigInt(45),
  ACCOUNT_PATCH_RESOURCES: window.BigInt(1) << window.BigInt(38),

  // Resources
  GET_RESOURCES: window.BigInt(1) << window.BigInt(34),
  CREATE_RESOURCES: window.BigInt(1) << window.BigInt(35),
  DELETE_RESOURCES: window.BigInt(1) << window.BigInt(36),

  // Claims
  ADMIN_PATIENT_IMPORT: window.BigInt(1) << window.BigInt(37),
  CLAIM_GET: window.BigInt(1) << window.BigInt(39),
  CLAIM_PATCH: window.BigInt(1) << window.BigInt(40),
  CLAIMS_GET: window.BigInt(1) << window.BigInt(41),

  // ClaimReport
  CLAIM_REPORT_GET: window.BigInt(1) << window.BigInt(46),
  CLAIM_REPORT_PATCH: window.BigInt(1) << window.BigInt(47),
  CLAIM_REPORTS_GET: window.BigInt(1) << window.BigInt(48),

  SURVEYS_GET: window.BigInt(1) << window.BigInt(22),

  // Alerts
  ALERT_ACTION: window.BigInt(1) << window.BigInt(49),

  // Alerts
  IMMUNOTHERAPY_REPORT: window.BigInt(1) << window.BigInt(50),

  MANAGE_CHILD_ACCOUNTS: window.BigInt(1) << window.BigInt(51),
  MANAGE_INSTANT_SURVEY_ASSESSMENTS: window.BigInt(1) << window.BigInt(52),

  // Assessment Performance — placeholder bit. The real permission flag
  // is assigned by the backend team during integration; until then the
  // route is left ungated so the page is visible to every user during
  // testing (see src/app/router/.../dashboard.js).
  ASSESSMENT_PERFORMANCE_VIEW: window.BigInt(1) << window.BigInt(53),

  // Bits 54-55 — patient engagement master flag transitions. The two
  // directions are gated independently (who may pause outreach and who
  // may resume it are different roles): 54 gates ENABLING
  // (false -> true), 55 gates DISABLING (true -> false). Either can be
  // held alone, both, or neither; viewing the flag or its history needs
  // no permission. The backend enforces the same rules server-side.
  PATIENT_ENGAGEMENT_ENABLE: window.BigInt(1) << window.BigInt(54),
  PATIENT_ENGAGEMENT_DISABLE: window.BigInt(1) << window.BigInt(55),

  // Bit 56 — selecting the manager-gated "permanent removal from QHS
  // communications" decline reason on assessments (backend Assessment
  // Decline Workflow, PR 2209). The backend enforces the same gate
  // server-side; the dialog only disables the option up front.
  ASSESSMENT_DECLINE_MANAGER_REASON: window.BigInt(1) << window.BigInt(56),

  // Providers PATCH endpoint (edit provider name/title/NPI), added 2026-08.
  ACCOUNT_PROVIDER_PATCH: window.BigInt(1) << window.BigInt(59),

  // Bits 60-61 — dedicated view permissions for the Claims Manager and
  // BHI dashboards (backend 2026-08-21). Both pages rode on
  // ADMIN_PATIENT_IMPORT during their Phase 1 rollout.
  CLAIMS_MANAGER_VIEW: window.BigInt(1) << window.BigInt(60),
  BHI_DASHBOARD_VIEW: window.BigInt(1) << window.BigInt(61),

  // Bits 62-66 — Programs as an account module (QHSPermissionType.PROGRAM_*,
  // design spec 2026-09-14, API contract
  // api/tasks/prompt-programs-account-features-dashboard.md).
  // PROGRAM_GET + PROGRAMS_GET are granted to every user of an account with
  // `accountPermissions.enablePrograms` on; PROGRAM_CREATE / PROGRAM_PATCH /
  // PROGRAM_DELETE go to sponsors and users with "manage users". Every
  // program route additionally requires the account-level flag
  // (RequireAccountFeature) regardless of which of these bits the user holds.
  // The journeys list is gated on PROGRAMS_GET and a single journey on
  // PROGRAM_GET — the patient dashboard's Programs tab gates on the same
  // bit the API checks; the Journeys page itself still rides on the admin
  // bit (ADMIN_PATIENT_IMPORT) from its phase-1 rollout.
  PROGRAM_GET: window.BigInt(1) << window.BigInt(62),
  PROGRAM_PATCH: window.BigInt(1) << window.BigInt(63),
  PROGRAM_DELETE: window.BigInt(1) << window.BigInt(64),
  PROGRAM_CREATE: window.BigInt(1) << window.BigInt(65),
  PROGRAMS_GET: window.BigInt(1) << window.BigInt(66),

  // Bit 67 — Permissions Testing (non-production only, backend branch
  // feature/permissions-testing, 2026-09-04). Grants access to the
  // /testing/permissions API and therefore to the dashboard page that
  // drives it. Named PERMISSIONS_MANAGE (not e.g.
  // PERMISSIONS_TESTING_MANAGE) to match the backend's own name for
  // this bit; kept as-is for parity rather than renamed for local
  // clarity.
  PERMISSIONS_MANAGE: window.BigInt(1) << window.BigInt(67),

  // Sponsor-side switch for the Programs module on a child account
  // (design spec 2026-09-14). Bit 68, confirmed by the API branch
  // feature/programs-account-features.
  ACCOUNT_PATCH_ENABLE_PROGRAMS: window.BigInt(1) << window.BigInt(68),

  // Bits 69-73 — Services (the pages that used to be called Programs:
  // BHI and the other enrolments; `/programs` endpoints). API branch
  // feature/services-own-permissions, 2026-09-17. They replace the
  // PROGRAM_* bits FOR SERVICES ONLY, so Services can never again be tied
  // to the Programs account switch by accident: role-granted, no account
  // flag — every clinic user reads (SERVICE_GET, SERVICES_GET), sponsor
  // users get all five on their own account and on a child account.
  SERVICE_GET: window.BigInt(1) << window.BigInt(69),
  SERVICE_PATCH: window.BigInt(1) << window.BigInt(70),
  SERVICE_DELETE: window.BigInt(1) << window.BigInt(71),
  SERVICE_CREATE: window.BigInt(1) << window.BigInt(72),
  SERVICES_GET: window.BigInt(1) << window.BigInt(73),

  // Zoho Books billing link (customer + salesperson) on a sponsor's child
  // account: PATCH /integrations/zoho and the two picker endpoints. API
  // grants it only to DS users with Administer Claim Reports, on child
  // accounts. Bit 74, API branch feature/zoho-contact-link-salesperson.
  ACCOUNT_PATCH_ZOHO: window.BigInt(1) << window.BigInt(74),
};

export default permissions;
